import { useMutation } from "@tanstack/react-query";
import { createPaymentLink } from "@/http/paymentApi";
import { CreatePaymentLinkRequest } from "@/@types/catalog.types";

export const useCreatePaymentLinkMutation = () => {
  return useMutation({
    mutationFn: async (data: CreatePaymentLinkRequest) => {
      const response = await createPaymentLink(data);
      return response.data;
    },
  });
};
